export interface ISource {
  value: string;
  label: string;
}

export const SourceOfFunds: ISource[] = [
  { value: 'SAV', label: 'Savings' },
  { value: 'SAL_PROP', label: 'Sales of property' },
  { value: 'MAT_POL', label: 'Maturity/Surrender of Policy' },
  { value: 'EMP_INC', label: 'Employment/Trade Income' },
]

export const SourceOfWealths: ISource[] = [
  { value: 'EMP_INC', label: 'Employment/ Trade income' },
  { value: 'REN_INC', label: 'Rental income' },
  { value: 'INV_INC', label: 'Investment income' },
]

// Evergreen (Secure Saver) Nature of Business list 

export const relationship = [
  {id:"Parent",label:'Parent'},
  {id:"Step-parent",label:'Step-parent'},
  {id:"Child",label:'Child'},
  {id:"Step-child",label:'Step-child'},
  {id:"Adopted child",label:'Adopted child'},
  {id:"Spouse",label:'Spouse'},
  {id:"Sibling",label:'Sibling'},
  {id:"Step-sibling",label:'Step-sibling'},
  {id:"Adopted Sibling",label:'Adopted Sibling'},
  {id:"Others",label:'Others'},
]

export const interBankRelationship = [
{id:"Spouse", label:"Spouse"},
{id:"Siblings", label:"Siblings"},
{id:"Parent", label:"Parent"},
{id:"Child", label:"Child"},
{id:"Others", label:"Others"},
]